<!--
  ~ Copyright (C) 2018 Robert Bosch GmbH Copyright (C) 2018 Robert Bosch Manufacturing Solutions GmbH, Germany. All rights reserved.
  -->
<bci-content>
  <bci-sidebar
    [sidebarLinks]="sidebarLinks"
    [applicationTitle]="applicationTitle"
    [applicationTitleLineTwo]="applicationTitleLineTwo"
  >
    <bci-sidebar-footer
      [sidebarFooterLinks]="sidebarFooterLinks"
      [showTime]="showSidebarFooterTime"
      [userInfo]="userInfo"
    >
    </bci-sidebar-footer>

    <bci-header> </bci-header>

    <div class="content">
      <ng-content></ng-content>
    </div>
  </bci-sidebar>
</bci-content>
